import { EventsSearchArg } from "./schema";
import { FetchArgs } from "@reduxjs/toolkit/query";
import { queryBuilder } from "./eventsApi";

export const searchFilteredEventsQuery = (arg: EventsSearchArg):  FetchArgs => {
  const { page, size, filter } = arg
  const url = `/api/v1/events/search`
  return queryBuilder(size, page, url, filter)
}